import { Button, Form, Input } from 'antd';
import PriceInput from '../components/price-input';
import { useState } from "react";
import layoutStorage from "../storages/layout-storage";
import itemsStorage from "../storages/items-storage";
import { normalizeUrl } from "../helpers/normalize-url";
import IconAlert from "@ant-design/icons/AlertOutlined";
import RestApiQuery from "../helpers/rest-api-query";

/* eslint-disable-next-line */
export interface AddItemVariantFormProps {}

export function AddItemVariantForm(props: AddItemVariantFormProps) {
  const [price, setPrice] = useState<number>(0);
  const [priceUAH, setPriceUAH] = useState<number>(0);
  const [url, setUrl] = useState<string>("");
  const [delivery, setDelivery] = useState<number>(0);
  const [isUrlAlreadyExists, setIsUrlAlreadyExists] = useState<boolean>(false);

  const { isAddItemDialogOpened } = layoutStorage;

  const handleSubmit = () => {
    RestApiQuery.post(`/api/item/${isAddItemDialogOpened}/variant`, {
        price,
        url,
        delivery,
      }
    ).then(() => {
      itemsStorage.loadItems();
    });
  }

  const handleUrlChange = (newUrl: string) => {
    const { variants } = itemsStorage.items.find((item) => item._id === isAddItemDialogOpened) || { variants: [] };
    const normalizedUrl = normalizeUrl(newUrl);
    const isUrlAlreadyExists = !!variants?.some((variant) => variant.url === normalizedUrl);
    setIsUrlAlreadyExists(isUrlAlreadyExists);
    setUrl(normalizedUrl);
  }

  return (
    <Form>
      <Form.Item label="Url">
        <Input
          placeholder="Url"
          value={url}
          onChange={(e) => handleUrlChange(e.target.value)}
          addonAfter={isUrlAlreadyExists && <IconAlert />}
        />
      </Form.Item>
      <Form.Item label="Price">
        <PriceInput price={price} onChange={(newPrice) => setPrice(newPrice)} />
      </Form.Item>
      <Form.Item label="Price UAH">
        <PriceInput price={priceUAH} onChange={(newPrice) => {
          setPrice(Math.round(newPrice / 37.45 * 100) / 100)
          setPriceUAH(newPrice);
        }}
        />
      </Form.Item>
      <Form.Item label="Delivery">
        <PriceInput price={delivery} onChange={(newPrice) => setDelivery(newPrice)} />
      </Form.Item>
      <Button type="primary" onClick={handleSubmit}>Add</Button>
    </Form>
  );
}

export default AddItemVariantForm;
